import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, GetAmphoraOrderInfoSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<Record<string, unknown>>

export function useAmphoraSearchOrderMutation() {
  return useMutation({
    mutationFn: async (data: z.infer<typeof GetAmphoraOrderInfoSchema>) => {
      return axios
        .post<Response>(`/integrations/amphora/search`, data)
        .then((response) => response.data.data)
    },
  })
}
